import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDashboardComponent implements OnInit {
    public loading: boolean = false;
    public sourceStatus: string = 'loading';
    public generationStatus: string = 'unavailable';
    public error: any = null;
    public sourceRequestId: string = null;
    public totalDocuments: number = 0;
    public documents: any[] = [];
    public workflowStatus: string = 'unavailable';
    public workflowMetrics: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load() {
        if (this.loading) return;

        this.loading = true;
        this.error = null;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('overview');
            if (code !== 200) {
                this.applyError(data);
                return;
            }
            this.applyOverview(data);
        } catch (_error) {
            this.applyError(null);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async openSidebar() {
        await this.service.status.toggle('navbar', false);
    }

    public formatNumber(value: number) {
        return new Intl.NumberFormat('ko-KR').format(value || 0);
    }

    public publicationLabel(status: string) {
        const labels: any = {
            published: '게시',
            draft: '초안',
            archived: '보관',
        };
        return labels[status] || status || '-';
    }

    public publicationStatusClass(status: string) {
        const styles: any = {
            published: 'bg-green-50 text-green-700',
            draft: 'bg-amber-50 text-amber-700',
            archived: 'bg-zinc-100 text-zinc-600',
        };
        return styles[status] || 'bg-zinc-100 text-zinc-600';
    }

    public availabilityLabel(document: any) {
        const availability = document && document.availability
            ? document.availability
            : {};
        const labels: string[] = [];
        if (availability.xml === true) labels.push('XML');
        if (availability.ocr === true) labels.push('OCR');
        if (availability.pages === true) labels.push('페이지');
        if (availability.chunks === true) labels.push('청크');
        return labels.length > 0 ? labels.join(' · ') : '제공 없음';
    }

    public stageLabel(stage: string) {
        return ({
            not_started: '미시작',
            source: '원문 준비',
            entity: '개체 검수',
            relation: '관계 검수',
            graph: '그래프 확정',
        } as any)[stage] || stage || '-';
    }

    public workflowLabel(status: string) {
        return ({
            not_started: '미시작',
            pending: '다음 작업 있음',
            held: '보류',
            blocked: '확인 필요',
            completed: '완료',
        } as any)[status] || status || '-';
    }

    public workflowClass(status: string) {
        const styles: any = {
            pending: 'bg-amber-50 text-amber-800',
            held: 'bg-violet-50 text-violet-700',
            blocked: 'bg-red-50 text-red-700',
            completed: 'bg-green-50 text-green-700',
        };
        return styles[status] || 'bg-zinc-100 text-zinc-600';
    }

    public openWorkflow(document: any) {
        const action = document?.workflow?.next_action;
        location.href = action?.url || '/documents';
    }

    public openDocuments() {
        location.href = '/documents';
    }

    private applyOverview(data: any) {
        if (!data || typeof data !== 'object') {
            throw new Error('Invalid dashboard response');
        }
        const source = data.source;
        const counts = data.metrics;
        if (
            !source
            || !['available', 'empty'].includes(source.status)
            || !counts
            || !Array.isArray(data.documents)
        ) {
            throw new Error('Invalid dashboard response');
        }

        if (!Number.isInteger(counts.total_documents) || counts.total_documents < 0) {
            throw new Error('Invalid dashboard metrics');
        }

        this.sourceStatus = source.status;
        this.generationStatus = data.generation && data.generation.status
            ? data.generation.status
            : 'unavailable';
        this.sourceRequestId = typeof source.request_id === 'string'
            ? source.request_id
            : null;
        this.totalDocuments = counts.total_documents;
        this.documents = data.documents;
        const workflow = data.workflow && typeof data.workflow === 'object'
            ? data.workflow
            : { status: 'unavailable', metrics: {} };
        this.workflowStatus = workflow.status || 'unavailable';
        this.workflowMetrics = workflow.metrics || {};
        this.error = null;
    }

    private applyError(data: any) {
        const source = data && typeof data === 'object' ? data.source : null;
        const apiError = source && typeof source === 'object' ? source.error : null;
        const message = apiError && typeof apiError.message === 'string'
            ? apiError.message
            : '문서 데이터를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
        const requestId = source && typeof source.request_id === 'string'
            ? source.request_id
            : null;

        this.sourceStatus = 'error';
        this.generationStatus = 'unavailable';
        this.sourceRequestId = requestId;
        this.totalDocuments = 0;
        this.documents = [];
        this.workflowStatus = 'unavailable';
        this.workflowMetrics = {};
        this.error = {
            message: message,
            requestId: requestId,
        };
    }

}

export default PageDashboardComponent;